import { Message, MessageContentType } from '@tribeplatform/gql-client/types'
import { useAuthMember } from '@tribeplatform/react-sdk/hooks'

import { useStaticIntl } from '../../../i18n/index.js'
import { chatLogMessageFactory } from '../utils/chat.utils.js'

interface Props {
  message: Message
}

export const ChatLogMessage = ({ message }: Props) => {
  const { data: authMember } = useAuthMember()
  const getChatLogMessage = useStaticIntl(chatLogMessageFactory)
  if (message.contentType !== MessageContentType.ChatLog) {
    return null
  }

  const chatLogMessages = getChatLogMessage(message, authMember)

  if (!chatLogMessages) {
    return null
  }

  return (
    <div className="flex flex-col gap-4">
      {chatLogMessages.map(message => (
        <div className="flex justify-center" key={message}>
          <div className="bg-surface-subdued p-3 text-xs rounded-base inline-block max-w-[80%] sm:max-w-[50%] text-center italic text-content-muted">
            {message}
          </div>
        </div>
      ))}
    </div>
  )
}
